// eslint-disable-next-line no-unused-vars
var itemsFre = {
    "1": "Master Ball",
    "2": "Hyper Ball",
    "3": "Super Ball",
    "4": "Poké Ball",
    "5": "Safari Ball",
    "6": "Filet Ball",
    "7": "Scuba Ball",
    "8": "Faiblo Ball",
    "9": "Bis Ball",
    "10": "Chrono Ball",
    "11": "Luxe Ball",
    "12": "Honor Ball",
    "13": "Sombre Ball",
    "14": "Soin Ball",
    "15": "Rapide Ball",
    "16": "Mémoire Ball",
    "17": "Potion",
    "18": "Antidote",
    "19": "Anti-Br\u00fble",
    "20": "Antigel",
    "21": "Réveil",
    "22": "Anti-Para",
    "23": "Guérison",
    "24": "Potion Max",
    "25": "Hyper Potion",
    "26": "Super Potion",
    "27": "Total Soin",
    "28": "Rappel",
    "29": "Rappel Max",
    "30": "Eau Fra\u00eeche",
    "31": "Soda Cool",
    "32": "Limonade",
    "33": "Lait Meumeu",
    "34": "Poudrénergie",
    "35": "Racinénergie",
    "36": "Poudre Soin",
    "37": "Herbe Rappel",
    "38": "Huile",
    "39": "Huile Max",
    "40": "Élixir",
    "41": "Élixir Max",
    "42": "Lava Cookie",
    "43": "Jus de Baie",
    "44": "Cendre Sacrée",
    "45": "PV Plus",
    "46": "Protéine",
    "47": "Fer",
    "48": "Carbone",
    "49": "Calcium",
    "50": "Super Bonbon",
    "51": "PP Plus",
    "52": "Zinc",
    "53": "PP Max",
    "54": "Vieux G\u00e2teau",
    "55": "Garde-Stats",
    "56": "Muscle +",
    "57": "Attaque +",
    "58": "Défense +",
    "59": "Vitesse +",
    "60": "Précision +",
    "61": "Atq. Spé. +",
    "62": "Déf. Spé. +",
    "63": "Poké Poupée",
    "64": "Queue Skitty",
    "65": "Fl\u00fbte Bleue",
    "66": "Fl\u00fbte Jaune",
    "67": "Fl\u00fbte Rouge",
    "68": "Fl\u00fbte Noire",
    "69": "Fl\u00fbte Blanche",
    "70": "Sel Tréfonds",
    "71": "CoquilleTréfonds",
    "72": "Tesson Rouge",
    "73": "Tesson Bleu",
    "74": "Tesson Jaune",
    "75": "Tesson Vert",
    "76": "Super Repousse",
    "77": "Repousse Max",
    "79": "Repousse",
    "80": "Pierre Soleil",
    "81": "Pierre Lune",
    "82": "Pierre Feu",
    "83": "Pierre Foudre",
    "84": "Pierre Eau",
    "85": "Pierre Plante",
    "86": "Petit Champi",
    "87": "Gros Champi",
    "88": "Perle",
    "89": "Grande Perle",
    "90": "Poussi\u00e8re Étoile",
    "91": "Morceau d'Étoile",
    "92": "Pépite",
    "93": "Écaille C\u0153ur",
    "94": "Miel",
    "95": "Fertipousse",
    "96": "Fertihumide",
    "97": "Fertistable",
    "98": "Fertiglu",
    "99": "Fossile Racine",
    "100": "Fossile Griffe",
    "101": "Nautile",
    "102": "Fossile D\u00f4me",
    "103": "Vieil Ambre",
    "104": "Fossile Armure",
    "105": "Fossile Cr\u00e2ne",
    "106": "Os Rare",
    "107": "Pierre Éclat",
    "108": "Pierre Nuit",
    "109": "Pierre Aube",
    "110": "Pierre Ovale",
    "111": "Clé de Vo\u00fbte",
    "112": "Orbe Platiné",
    "116": "Module Aqua",
    "117": "Module Choc",
    "118": "Module Pyro",
    "119": "Module Cryo",
    "120": "???",
    "129": "???",
    "130": "???",
    "131": "???",
    "132": "???",
    "133": "???",
    "134": "Chococ\u0153ur",
    "135": "Orbe Adamant",
    "136": "Orbe Perlé",
    "137": "Lettre Salut",
    "138": "Lettre Fan",
    "139": "Lettre Invit",
    "140": "Lettre Merci",
    "141": "Lettre Demande",
    "142": "Lettre Avis",
    "143": "Lettre Réponse",
    "144": "Lettre Pont S",
    "145": "Lettre Pont Y",
    "146": "Lettre Pont F",
    "147": "Lettre Pont H",
    "148": "Lettre Pont I",
    "149": "Baie Ceriz",
    "150": "Baie Maron",
    "151": "Baie P\u00eacha",
    "152": "Baie Fraive",
    "153": "Baie Willia",
    "154": "Baie Mepo",
    "155": "Baie Oran",
    "156": "Baie Kika",
    "157": "Baie Prine",
    "158": "Baie Sitrus",
    "159": "Baie Figuy",
    "160": "Baie Wiki",
    "161": "Baie Mago",
    "162": "Baie Gowav",
    "163": "Baie Papaya",
    "164": "Baie Framby",
    "165": "Baie Remu",
    "166": "Baie Nanab",
    "167": "Baie Repoi",
    "168": "Baie Nanana",
    "169": "Baie Grena",
    "170": "Baie Alga",
    "171": "Baie Qualot",
    "172": "Baie Lonme",
    "173": "Baie Résin",
    "174": "Baie Tamato",
    "175": "Baie Siam",
    "176": "Baie Mangou",
    "177": "Baie Rabuta",
    "178": "Baie Tronci",
    "179": "Baie Kiwan",
    "180": "Baie Palma",
    "181": "Baie Stekpa",
    "182": "Baie Durin",
    "183": "Baie Myrte",
    "184": "Baie Chocco",
    "185": "Baie Pocpoc",
    "186": "Baie Parma",
    "187": "Baie Ratam",
    "188": "Baie Nanone",
    "189": "Baie Pomroz",
    "190": "Baie Kébia",
    "191": "Baie Jouca",
    "192": "Baie Cobaba",
    "193": "Baie Yapap",
    "194": "Baie Panga",
    "195": "Baie Charti",
    "196": "Baie Sédra",
    "197": "Baie Fraigo",
    "198": "Baie Lampou",
    "199": "Baie Babiri",
    "200": "Baie Zalis",
    "201": "Baie Lichii",
    "202": "Baie Lingan",
    "203": "Baie Sailak",
    "204": "Baie Pitaye",
    "205": "Baie Abriko",
    "206": "Baie Lansat",
    "207": "Baie Frista",
    "208": "Baie Enigma",
    "209": "Baie Micle",
    "210": "Baie Chérim",
    "211": "Baie Jaboca",
    "212": "Baie Pommo",
    "213": "Poudre Claire",
    "214": "Herbe Blanche",
    "215": "Bracelet Macho",
    "217": "Vive Griffe",
    "218": "Grelot Zen",
    "219": "Herbe Mental",
    "220": "Bandeau Choix",
    "221": "Roche Royale",
    "222": "Poudre Argentée",
    "223": "Pi\u00e8ce Rune",
    "224": "Rune Purifiante",
    "225": "Rosée \u00c2me",
    "226": "Dent Océan",
    "227": "Écaille Océan",
    "228": "Boule Fumée",
    "229": "Pierre Stase",
    "230": "Bandeau",
    "231": "\u0152uf Chance",
    "232": "Lentilscope",
    "233": "Peau Métal",
    "234": "Restes",
    "235": "Écaille Draco",
    "236": "Balle Lumi\u00e8re",
    "237": "Sable Doux",
    "238": "Pierre Dure",
    "239": "Graine Miracle",
    "240": "Lunettes Noires",
    "241": "Ceinture Noire",
    "242": "Aimant",
    "243": "Eau Mystique",
    "244": "Bec Pointu",
    "245": "Pic Venin",
    "246": "Glace Éternelle",
    "247": "Rune Sort",
    "248": "Cuill\u00e8re Tordue",
    "249": "Charbon",
    "250": "Croc Dragon",
    "251": "Mouchoir Soie",
    "252": "Améliorator",
    "253": "Grelot Coque",
    "254": "Encens Mer",
    "255": "Encens Doux",
    "256": "Poing Chance",
    "257": "Poudre Métal",
    "258": "Masse Os",
    "259": "Poireau",
    "260": "Foulard Rouge",
    "261": "Foulard Bleu",
    "262": "Foulard Rose",
    "263": "Foulard Vert",
    "264": "Foulard Jaune",
    "265": "Loupe",
    "266": "Bandeau Muscle",
    "267": "Lunettes Sages",
    "268": "Ceinture Pro",
    "269": "Lumargile",
    "270": "Orbe Vie",
    "271": "Herbe Pouvoir",
    "272": "Orbe Toxique",
    "273": "Orbe Flamme",
    "274": "Poudre Vite",
    "275": "Ceinture Force",
    "276": "Lentille Zoom",
    "277": "Métronome",
    "278": "Balle Fer",
    "279": "Ralentiqueue",
    "280": "N\u0153ud Destin",
    "281": "Boue Noire",
    "282": "Roche Glace",
    "283": "Roche Lisse",
    "284": "Roche Chaude",
    "285": "Roche Humide",
    "286": "Accro Griffe",
    "287": "Mouchoir Choix",
    "288": "Piquants",
    "289": "Poignet Pouvoir",
    "290": "Ceinture Pouvoir",
    "291": "Lentille Pouvoir",
    "292": "Bandeau Pouvoir",
    "293": "Cha\u00eene Pouvoir",
    "294": "Poids Pouvoir",
    "295": "Carapace Mue",
    "296": "Grosse Racine",
    "297": "Lunettes Choix",
    "298": "Plaque Flamme",
    "299": "Plaque Hydro",
    "300": "Plaque Volt",
    "301": "Plaque Herbe",
    "302": "Plaque Glace",
    "303": "Plaque Poing",
    "304": "Plaque Toxicité",
    "305": "Plaque Terre",
    "306": "Plaque Ciel",
    "307": "Plaque Esprit",
    "308": "Plaque Insecte",
    "309": "Plaque Roc",
    "310": "Plaque Fant\u00f4me",
    "311": "Plaque Draco",
    "312": "Plaque Ombre",
    "313": "Plaque Fer",
    "314": "Encens Bizarre",
    "315": "Encens Roc",
    "316": "Encens Plein",
    "317": "Encens Vague",
    "318": "Encens Fleur",
    "319": "Encens Veine",
    "320": "Encens Pur",
    "321": "Protecteur",
    "322": "Électriseur",
    "323": "Magmariseur",
    "324": "CD Douteux",
    "325": "Tissu Fauche",
    "326": "Griffe Rasoir",
    "327": "Croc Rasoir",
    "328": "CT001",
    "329": "CT002",
    "330": "CT003",
    "331": "CT004",
    "332": "CT005",
    "333": "CT006",
    "334": "CT007",
    "335": "CT008",
    "336": "CT009",
    "337": "CT010",
    "338": "CT011",
    "339": "CT012",
    "340": "CT013",
    "341": "CT014",
    "342": "CT015",
    "343": "CT016",
    "344": "CT017",
    "345": "CT018",
    "346": "CT019",
    "347": "CT020",
    "348": "CT021",
    "349": "CT022",
    "350": "CT023",
    "351": "CT024",
    "352": "CT025",
    "353": "CT026",
    "354": "CT027",
    "355": "CT028",
    "356": "CT029",
    "357": "CT030",
    "358": "CT031",
    "359": "CT032",
    "360": "CT033",
    "361": "CT034",
    "362": "CT035",
    "363": "CT036",
    "364": "CT037",
    "365": "CT038",
    "366": "CT039",
    "367": "CT040",
    "368": "CT041",
    "369": "CT042",
    "370": "CT043",
    "371": "CT044",
    "372": "CT045",
    "373": "CT046",
    "374": "CT047",
    "375": "CT048",
    "376": "CT049",
    "377": "CT050",
    "378": "CT051",
    "379": "CT052",
    "380": "CT053",
    "381": "CT054",
    "382": "CT055",
    "383": "CT056",
    "384": "CT057",
    "385": "CT058",
    "386": "CT059",
    "387": "CT060",
    "388": "CT061",
    "389": "CT062",
    "390": "CT063",
    "391": "CT064",
    "392": "CT065",
    "393": "CT066",
    "394": "CT067",
    "395": "CT068",
    "396": "CT069",
    "397": "CT070",
    "398": "CT071",
    "399": "CT072",
    "400": "CT073",
    "401": "CT074",
    "402": "CT075",
    "403": "CT076",
    "404": "CT077",
    "405": "CT078",
    "406": "CT079",
    "407": "CT080",
    "408": "CT081",
    "409": "CT082",
    "410": "CT083",
    "411": "CT084",
    "412": "CT085",
    "413": "CT086",
    "414": "CT087",
    "415": "CT088",
    "416": "CT089",
    "417": "CT090",
    "418": "CT091",
    "419": "CT092",
    "426": "CT099",
    "427": "CT100",
    "428": "Explorakit",
    "429": "Sac Butin",
    "430": "Livre R\u00e8gles",
    "432": "Carte \u00e0 Points",
    "433": "Notes d'Aventure",
    "434": "Bo\u00eete \u00e0 Sceaux",
    "435": "Coffret Mode",
    "436": "Sac Sceaux",
    "437": "Registre Ami",
    "438": "Clé Parc Éolien",
    "439": "Vieux Grigri",
    "441": "Cha\u00eene Rouge",
    "443": "Cherch'Combat",
    "444": "Bo\u00eete Jetons",
    "448": "Kwakarrosoir",
    "449": "Bo\u00eete \u00e0 Poffins",
    "451": "Clé de Chambre",
    "452": "Lettre Chen",
    "453": "Plume Lune",
    "454": "Carte Membre",
    "455": "Fl\u00fbte Azur",
    "456": "Passe Bateau",
    "458": "Pierre Magma",
    "459": "Colis",
    "460": "Bon 1",
    "461": "Bon 2",
    "462": "Bon 3",
    "463": "Clé du Hangar",
    "464": "Rem\u00e8de Secret",
    "467": "Clé Secr\u00e8te",
    "468": "Bo\u00eete Noigrume",
    "469": "Carnet Zarbi",
    "470": "Plante-Baies",
    "472": "Carte Bleue",
    "473": "Queue Ramoloss",
    "475": "Carte Magnétique",
    "476": "Clé Sous-Sol",
    "477": "Carapuce \u00e0 O",
    "478": "Écaille Rouge",
    "479": "Objet perdu",
    "480": "Passe Train",
    "481": "Partie Machine",
    "482": "Argent'Aile",
    "483": "Arc-en-Ci'Aile",
    "484": "\u0152uf Myst\u00e8re",
    "485": "Noigrume Rouge",
    "486": "Noigrume Bleu",
    "487": "Noigrume Jaune",
    "488": "Noigrume Vert",
    "489": "Noigrume Rose",
    "490": "Noigrume Blanc",
    "491": "Noigrume Noir",
    "492": "Speed Ball",
    "493": "Niveau Ball",
    "494": "App\u00e2t Ball",
    "495": "Masse Ball",
    "496": "Love Ball",
    "497": "Copain Ball",
    "498": "Lune Ball",
    "499": "Compét'Ball",
    "501": "Album Photo",
    "502": "Lecteur GB",
    "504": "Bonbon Rage",
    "505": "Carte Mémo01",
    "506": "Carte Mémo02",
    "507": "Carte Mémo03",
    "508": "Carte Mémo04",
    "509": "Carte Mémo05",
    "510": "Carte Mémo06",
    "511": "Carte Mémo07",
    "512": "Carte Mémo08",
    "513": "Carte Mémo09",
    "514": "Carte Mémo10",
    "515": "Carte Mémo11",
    "516": "Carte Mémo12",
    "517": "Carte Mémo13",
    "518": "Carte Mémo14",
    "519": "Carte Mémo15",
    "520": "Carte Mémo16",
    "521": "Carte Mémo17",
    "522": "Carte Mémo18",
    "523": "Carte Mémo19",
    "524": "Carte Mémo20",
    "525": "Carte Mémo21",
    "526": "Carte Mémo22",
    "527": "Carte Mémo23",
    "528": "Carte Mémo24",
    "529": "Carte Mémo25",
    "530": "Carte Mémo26",
    "531": "Carte Mémo27",
    "532": "Orbe Vert",
    "533": "Poké Écrin",
    "534": "Gemme Rouge",
    "535": "Gemme Bleue",
    "536": "Mystécristal",
    "537": "Bel'Écaille",
    "538": "Évoluroc",
    "539": "Pierrallégée",
    "540": "Casque Brut",
    "541": "Ballon",
    "542": "Carton Rouge",
    "543": "Point de Mire",
    "544": "Bande Étreinte",
    "545": "Bulbe",
    "546": "Pile",
    "547": "Bouton Fuite",
    "548": "Joyau Feu",
    "549": "Joyau Eau",
    "550": "Joyau Électrik",
    "551": "Joyau Plante",
    "552": "Joyau Glace",
    "553": "Joyau Combat",
    "554": "Joyau Poison",
    "555": "Joyau Sol",
    "556": "Joyau Vol",
    "557": "Joyau Psy",
    "558": "Joyau Insecte",
    "559": "Joyau Roche",
    "560": "Joyau Spectre",
    "561": "Joyau Dragon",
    "562": "Joyau Tén\u00e8bres",
    "563": "Joyau Acier",
    "564": "Joyau Normal",
    "565": "Plume Santé",
    "566": "Plume Force",
    "567": "Plume Armure",
    "568": "Plume Esprit",
    "569": "Plume Mental",
    "570": "Plume Sprint",
    "571": "Jolie Plume",
    "572": "Fossile Plaque",
    "573": "Fossile Plume",
    "574": "Passe Liberté",
    "575": "Offrisph\u00e8re",
    "576": "R\u00eave Ball",
    "577": "Poké Plumet",
    "578": "Bo\u00eete Parure",
    "579": "Cr\u00e2ne Dragon",
    "580": "Champi Suave",
    "581": "Maxi Pépite",
    "582": "Perle Triple",
    "583": "Morceau Com\u00e8te",
    "584": "Vieux Sou",
    "585": "Vieil Écu",
    "586": "Vieux Ducat",
    "587": "Vieux Vase",
    "588": "Vieux Bijou",
    "589": "Vieux Santon",
    "590": "Vieux Tortil",
    "591": "Glace Volute",
    "592": "Muscle 2",
    "593": "Vitesse 2",
    "594": "Atq. Spé. 2",
    "595": "Déf. Spé. 2",
    "596": "Défense 2",
    "597": "Attaque 2",
    "598": "Précision 2",
    "599": "Vitesse 3",
    "600": "Atq. Spé. 3",
    "601": "Déf. Spé. 3",
    "602": "Défense 3",
    "603": "Attaque 3",
    "604": "Précision 3",
    "605": "Vitesse 6",
    "606": "Atq. Spé. 6",
    "607": "Déf. Spé. 6",
    "608": "Défense 6",
    "609": "Attaque 6",
    "610": "Précision 6",
    "611": "Appel Talent",
    "612": "Jette Objet",
    "613": "Appel Objet",
    "614": "Réamor\u00e7age",
    "615": "Muscle 3",
    "616": "Galet Blanc",
    "617": "Galet Noir",
    "618": "CT093",
    "619": "CT094",
    "620": "CT095",
    "621": "Vokit",
    "622": "???",
    "623": "Courrier 1",
    "624": "Courrier 2",
    "625": "Courrier 3",
    "626": "Vokit",
    "627": "Bo\u00eete Médailles",
    "630": "Permis",
    "633": "Carte Plasma",
    "634": "Mouchoir Sale",
    "635": "Nikodule",
    "636": "Objet Trouvé",
    "637": "Objet Trouvé",
    "639": "Vulné-Assurance",
    "640": "Veste de Combat",
    "644": "Plaque Pixie",
    "645": "Pilule Talent",
    "646": "Chantibonbon",
    "647": "Sachet Senteur",
    "648": "Lichen Lumineux",
    "649": "Boule de Neige",
    "650": "Lunettes Filtre",
    "652": "Fertibondance",
    "653": "Fertistantané",
    "654": "Fertibérance",
    "655": "Fertiprodige",
    "656": "Ectoplasmite",
    "657": "Gardevoirite",
    "658": "Pharampite",
    "659": "Florizarrite",
    "660": "Dracaufite X",
    "661": "Tortankite",
    "662": "Mewtwo\u00efte X",
    "663": "Mewtwo\u00efte Y",
    "664": "Braségalite",
    "665": "Charminite",
    "666": "Démolossite",
    "667": "Galekingite",
    "668": "Branettite",
    "669": "Tyranocivite",
    "670": "Cizayoxite",
    "671": "Scarabruite",
    "672": "Ptéra\u00efte",
    "673": "Lucarite",
    "674": "Blizzarite",
    "675": "Kangourexite",
    "676": "Léviatorite",
    "677": "Absolite",
    "678": "Dracaufite Y",
    "679": "Alakazamite",
    "680": "Scarhino\u00efte",
    "681": "Mysdibulite",
    "682": "Élecsprintite",
    "683": "Carchacrokite",
    "684": "Latiasite",
    "685": "Latiosite",
    "686": "Baie Selro",
    "687": "Baie Éka",
    "688": "Baie Rangma",
    "690": "CT096",
    "691": "CT097",
    "692": "CT098",
    "693": "CT099",
    "694": "CT100",
    "699": "Bon Réduction",
    "704": "Bibelot Bizarre",
    "708": "Galette Illumis",
    "709": "Sablé Yantreizh",
    "710": "Fossile M\u00e2choire",
    "711": "Fossile Nageoire",
    "715": "Joyau Fée",
    "752": "Laggronite",
    "753": "Jungkite",
    "754": "Ténéfixite",
    "755": "Altarite",
    "756": "Gallamite",
    "757": "Nanméou\u00efte",
    "758": "Métalossite",
    "759": "Sharpedite",
    "760": "Flagadossite",
    "761": "Steelixite",
    "762": "Roucarnagite",
    "763": "Oniglalite",
    "764": "Diancite",
    "767": "Caméruptite",
    "768": "Lockpinite",
    "769": "Drattakite",
    "770": "Dardargnite",
    "776": "Normazélite",
    "777": "Pyrozélite",
    "778": "Aquazélite",
    "779": "Voltazélite",
    "780": "Florazélite",
    "781": "Cryozélite",
    "782": "Combazélite",
    "783": "Toxizélite",
    "784": "Terrazélite",
    "785": "Aérozélite",
    "786": "Psychézélite",
    "787": "Insectozélite",
    "788": "Rocazélite",
    "789": "Spectrozélite",
    "790": "Dracozélite",
    "791": "Ténébrozélite",
    "792": "Métallozélite",
    "793": "Nymphézélite",
    "794": "Pikazélite",
    "795": "Capsule d'Argent",
    "796": "Capsule d'Or",
    "798": "Archézélite",
    "799": "Félinozélite",
    "800": "Oratozélite",
    "801": "Tokozélite",
    "802": "Marshadozélite",
    "803": "Alora\u00efzélite",
    "804": "Ronflézélite",
    "805": "Évolizélite",
    "806": "Mewzélite",
    "807": "Normazélite",
    "808": "Pyrozélite",
    "809": "Aquazélite",
    "810": "Voltazélite",
    "811": "Florazélite",
    "812": "Cryozélite",
    "813": "Combazélite",
    "814": "Toxizélite",
    "815": "Terrazélite",
    "816": "Aérozélite",
    "817": "Psychézélite",
    "818": "Insectozélite",
    "819": "Rocazélite",
    "820": "Spectrozélite",
    "821": "Dracozélite",
    "822": "Ténébrozélite",
    "823": "Métallozélite",
    "824": "Nymphézélite",
    "825": "Pikazélite",
    "826": "Archézélite",
    "827": "Félinozélite",
    "828": "Oratozélite",
    "829": "Tokozélite",
    "830": "Marshadozélite",
    "831": "Alora\u00efzélite",
    "832": "Ronflézélite",
    "833": "Évolizélite",
    "834": "Mewzélite",
    "835": "Pikachazélite",
    "836": "Pikachazélite",
    "844": "Festicket",
    "846": "Orbe Frousse",
    "849": "Pierre Glace",
    "851": "Ultra Ball",
    "852": "Malasada Maxi",
    "853": "Nectar Rouge",
    "854": "Nectar Jaune",
    "855": "Nectar Rose",
    "856": "Nectar Mauve",
    "861": "Baie Framby argentée",
    "862": "Baie Framby dorée",
    "863": "Baie Nanab argentée",
    "864": "Baie Nanab dorée",
    "865": "Baie Nanana argentée",
    "866": "Baie Nanana dorée",
    "867": "???",
    "868": "???",
    "869": "???",
    "870": "???",
    "871": "???",
    "879": "Champ'Duit",
    "880": "Pare-Effet",
    "881": "Graine Électrik",
    "882": "Graine Psychique",
    "883": "Graine Brume",
    "884": "Graine Herbe",
    "885": "Ressort Détendu",
    "886": "Craie",
    "887": "Bille",
    "888": "Boucle d'Oreille",
    "889": "Galet de Verre",
    "890": "Feuille Dorée",
    "891": "Feuille Argentée",
    "892": "Boulette de Boue",
    "893": "Coquille du Sud",
    "894": "Lettre Végétale",
    "895": "Lettre Végétale",
    "896": "Petit Bouquet",
    "897": "???",
    "898": "???",
    "899": "???",
    "900": "Parfum",
    "901": "Super Parfum",
    "902": "Parfum Max",
    "903": "Crok'Argenta",
    "904": "ROM Combat",
    "905": "ROM Vol",
    "906": "ROM Poison",
    "907": "ROM Sol",
    "908": "ROM Roche",
    "909": "ROM Insecte",
    "910": "ROM Spectre",
    "911": "ROM Acier",
    "912": "ROM Feu",
    "913": "ROM Eau",
    "914": "ROM Plante",
    "915": "ROM Électrik",
    "916": "ROM Psy",
    "917": "ROM Glace",
    "918": "ROM Dragon",
    "919": "ROM Tén\u00e8bres",
    "920": "ROM Fée",
    "921": "Solgazélite",
    "922": "Lunazélite",
    "923": "Ultranécrozélite",
    "924": "Mimiquizélite",
    "925": "Lougarozélite",
    "926": "Éka\u00efzélite",
    "927": "Solgazélite",
    "928": "Lunazélite",
    "929": "Ultranécrozélite",
    "930": "Mimiquizélite",
    "931": "Lougarozélite",
    "932": "Éka\u00efzélite",
    "949": "Moti-Couveuse",
    "950": "Moti-Promo",
    "951": "Moti-Magot",
    "952": "Moti-Exp",
    "953": "Moti-C\u0153ur",
    "954": "Moti-App\u00e2t",
    "955": "Moti-Camouflage",
    "956": "Moti-Récup' PV",
    "957": "Moti-Récup' PP",
    "958": "Moti-Soutien",
    "959": "Moti-Capture",
    "960": "Bonbon Santé S",
    "961": "Bonbon Force S",
    "962": "Bonbon Armure S",
    "963": "Bonbon Esprit S",
    "964": "Bonbon Mental S",
    "965": "Bonbon Sprint S",
    "966": "Bonbon Santé M",
    "967": "Bonbon Force M",
    "968": "Bonbon Armure M",
    "969": "Bonbon Esprit M",
    "970": "Bonbon Mental M",
    "971": "Bonbon Sprint M",
    "972": "Bonbon Santé L",
    "973": "Bonbon Force L",
    "974": "Bonbon Armure L",
    "975": "Bonbon Esprit L",
    "976": "Bonbon Mental L",
    "977": "Bonbon Sprint L",
    "978": "Bonbon Bulbizarre",
    "979": "Bonbon Salam\u00e8che",
    "980": "Bonbon Carapuce",
    "981": "Bonbon Chenipan",
    "982": "Bonbon Aspicot",
    "983": "Bonbon Roucool",
    "984": "Bonbon Rattata",
    "985": "Bonbon Piafabec",
    "986": "Bonbon Abo",
    "987": "Bonbon Pikachu",
    "988": "Bonbon Sabelette",
    "989": "Bonbon Nidoran[Character1:female ]",
    "990": "Bonbon Nidoran[Character1:male ]",
    "991": "Bonbon Mélofée",
    "992": "Bonbon Goupix",
    "993": "Bonbon Rondoudou",
    "994": "Bonbon Nosferapti",
    "995": "Bonbon Mystherbe",
    "996": "Bonbon Paras",
    "997": "Bonbon Mimitoss",
    "998": "Bonbon Taupiqueur",
    "999": "Bonbon Miaouss",
    "1000": "Bonbon Psykokwak",
    "1001": "Bonbon Férosinge",
    "1002": "Bonbon Caninos",
    "1003": "Bonbon Ptitard",
    "1004": "Bonbon Abra",
    "1005": "Bonbon Machoc",
    "1006": "Bonbon Chétiflor",
    "1007": "Bonbon Tentacool",
    "1008": "Bonbon Racaillou",
    "1009": "Bonbon Ponyta",
    "1010": "Bonbon Ramoloss",
    "1011": "Bonbon Magnéti",
    "1012": "Bonbon Canarticho",
    "1013": "Bonbon Doduo",
    "1014": "Bonbon Otaria",
    "1015": "Bonbon Tadmorv",
    "1016": "Bonbon Kokiyas",
    "1017": "Bonbon Fantominus",
    "1018": "Bonbon Onix",
    "1019": "Bonbon Soporifik",
    "1020": "Bonbon Krabby",
    "1021": "Bonbon Voltorbe",
    "1022": "Bonbon Noeunoeuf",
    "1023": "Bonbon Osselait",
    "1024": "Bonbon Kicklee",
    "1025": "Bonbon Tygnon",
    "1026": "Bonbon Excelangue",
    "1027": "Bonbon Smogo",
    "1028": "Bonbon Rhinocorne",
    "1029": "Bonbon Leveinard",
    "1030": "Bonbon Saquedeneu",
    "1031": "Bonbon Kangourex",
    "1032": "Bonbon Hypotrempe",
    "1033": "Bonbon Poissir\u00e8ne",
    "1034": "Bonbon Stari",
    "1035": "Bonbon M. Mime",
    "1036": "Bonbon Insécateur",
    "1037": "Bonbon Lippoutou",
    "1038": "Bonbon Élektek",
    "1039": "Bonbon Scarabrute",
    "1040": "Bonbon Tauros",
    "1041": "Bonbon Magicarpe",
    "1042": "Bonbon Lokhlass",
    "1043": "Bonbon Métamorph",
    "1044": "Bonbon Évoli",
    "1045": "Bonbon Porygon",
    "1046": "Bonbon Amonita",
    "1047": "Bonbon Kabuto",
    "1048": "Bonbon Ptéra",
    "1049": "Bonbon Ronflex",
    "1050": "Bonbon Artikodin",
    "1051": "Bonbon Électhor",
    "1052": "Bonbon Sulfura",
    "1053": "Bonbon Minidraco",
    "1054": "Bonbon Mewtwo",
    "1055": "Bonbon Mew",
    "1056": "Bonbon Meltan",
    "1057": "Bonbon Magmar",
    "1058": "???",
    "1059": "???",
    "1060": "???",
    "1061": "???",
    "1062": "???",
    "1063": "???",
    "1064": "???",
    "1065": "???",
    "1066": "???",
    "1067": "???",
    "1068": "???",
    "1069": "???",
    "1070": "???",
    "1071": "???",
    "1072": "???",
    "1073": "???",
    "1084": "Saucisses",
    "1085": "Conserve de Bob",
    "1086": "Conserve de Bach",
    "1087": "Haricots",
    "1088": "Pain de Mie",
    "1089": "P\u00e2tes",
    "1090": "Champignons",
    "1091": "Queue Fumée",
    "1092": "Gros Poireau",
    "1093": "Pomme Juteuse",
    "1094": "Os \u00e0 Moelle",
    "1095": "Pommes de Terre",
    "1096": "Tubercule",
    "1097": "Légumes",
    "1098": "Fritures",
    "1099": "\u0152uf Dur",
    "1103": "Épée Rouillée",
    "1104": "Bouclier Rouillé",
    "1105": "Fossile Oiseau",
    "1106": "Fossile Poisson",
    "1107": "Fossile Dragon",
    "1108": "Fossile Aileron",
    "1109": "Fraise en Sucre",
    "1110": "C\u0153ur en Sucre",
    "1111": "Baie en Sucre",
    "1112": "Tr\u00e8fle en Sucre",
    "1113": "Fleur en Sucre",
    "1114": "Étoile en Sucre",
    "1115": "Ruban en Sucre",
    "1116": "Pomme Sucrée",
    "1117": "Pomme Acidulée",
    "1118": "Spray Gorge",
    "1119": "Sac Fuite",
    "1120": "Grosses Bottes",
    "1121": "Assurance Échec",
    "1122": "Chariot Distordu",
    "1123": "Parapluie Solide",
    "1124": "Bonbon Exp. XS",
    "1125": "Bonbon Exp. S",
    "1126": "Bonbon Exp. M",
    "1127": "Bonbon Exp. L",
    "1128": "Bonbon Exp. XL",
    "1129": "Bonbon Dynamax",
    "1130": "DT00",
    "1131": "DT01",
    "1132": "DT02",
    "1133": "DT03",
    "1134": "DT04",
    "1135": "DT05",
    "1136": "DT06",
    "1137": "DT07",
    "1138": "DT08",
    "1139": "DT09",
    "1140": "DT10",
    "1141": "DT11",
    "1142": "DT12",
    "1143": "DT13",
    "1144": "DT14",
    "1145": "DT15",
    "1146": "DT16",
    "1147": "DT17",
    "1148": "DT18",
    "1149": "DT19",
    "1150": "DT20",
    "1151": "DT21",
    "1152": "DT22",
    "1153": "DT23",
    "1154": "DT24",
    "1155": "DT25",
    "1156": "DT26",
    "1157": "DT27",
    "1158": "DT28",
    "1159": "DT29",
    "1160": "DT30",
    "1161": "DT31",
    "1162": "DT32",
    "1163": "DT33",
    "1164": "DT34",
    "1165": "DT35",
    "1166": "DT36",
    "1167": "DT37",
    "1168": "DT38",
    "1169": "DT39",
    "1170": "DT40",
    "1171": "DT41",
    "1172": "DT42",
    "1173": "DT43",
    "1174": "DT44",
    "1175": "DT45",
    "1176": "DT46",
    "1177": "DT47",
    "1178": "DT48",
    "1179": "DT49",
    "1180": "DT50",
    "1181": "DT51",
    "1182": "DT52",
    "1183": "DT53",
    "1184": "DT54",
    "1185": "DT55",
    "1186": "DT56",
    "1187": "DT57",
    "1188": "DT58",
    "1189": "DT59",
    "1190": "DT60",
    "1191": "DT61",
    "1192": "DT62",
    "1193": "DT63",
    "1194": "DT64",
    "1195": "DT65",
    "1196": "DT66",
    "1197": "DT67",
    "1198": "DT68",
    "1199": "DT69",
    "1200": "DT70",
    "1201": "DT71",
    "1202": "DT72",
    "1203": "DT73",
    "1204": "DT74",
    "1205": "DT75",
    "1206": "DT76",
    "1207": "DT77",
    "1208": "DT78",
    "1209": "DT79",
    "1210": "DT80",
    "1211": "DT81",
    "1212": "DT82",
    "1213": "DT83",
    "1214": "DT84",
    "1215": "DT85",
    "1216": "DT86",
    "1217": "DT87",
    "1218": "DT88",
    "1219": "DT89",
    "1220": "DT90",
    "1221": "DT91",
    "1222": "DT92",
    "1223": "DT93",
    "1224": "DT94",
    "1225": "DT95",
    "1226": "DT96",
    "1227": "DT97",
    "1228": "DT98",
    "1229": "DT99",
    "1230": "CT00",
    "1231": "Aromate Solo",
    "1232": "Aromate Rigide",
    "1233": "Aromate Mauvais",
    "1234": "Aromate Brave",
    "1235": "Aromate Assuré",
    "1236": "Aromate Malin",
    "1237": "Aromate L\u00e2che",
    "1238": "Aromate Relax",
    "1239": "Aromate Modeste",
    "1240": "Aromate Doux",
    "1241": "Aromate Foufou",
    "1242": "Aromate Discret",
    "1243": "Aromate Calme",
    "1244": "Aromate Gentil",
    "1245": "Aromate Prudent",
    "1246": "Aromate Malpoli",
    "1247": "Aromate Timide",
    "1248": "Aromate Pressé",
    "1249": "Aromate Jovial",
    "1250": "Aromate Na\u00eff",
    "1251": "Aromate Sérieux",
    "1252": "Morceau V\u0153u",
    "1253": "Théi\u00e8re F\u00ealée",
    "1254": "Théi\u00e8re Ébréchée",
    "1256": "Fruits",
    "1257": "Fromage Meumeu",
    "1258": "Épices",
    "1259": "Cr\u00e8me Fra\u00eeche",
    "1260": "Curry Instantané",
    "1261": "Lait de Coco",
    "1262": "Nouilles",
    "1263": "Steak Haché",
    "1264": "Poudre Gigamax",
    "1265": "Fragment V\u0153u",
    "1268": "???",
    "1579": "Maxi Miel",
    "1580": "Maxi Champi",
    "1581": "Branche Galanoa",
    "1582": "Bracelet Galanoa",
    "1588": "Armurium",
    "1592": "Couronne Galanoa",
    "1604": "Dynamaxium",
    "1606": "Patch Talent",
    "1608": "Pacifi-Temps",
    "1609": "Pacifi-Espace",
    "1610": "Pacifisph\u00e8re",
    "1611": "Fil de Liaison",
    "1612": "Muffin Tradition",
    "1613": "Noigrume",
    "1614": "Rusti-Muffin",
    "1615": "Double Extra",
    "1616": "Muscle +",
    "1617": "Papillote Choix",
    "1618": "Bouchée Double",
    "1619": "En-cas Contraire",
    "1620": "Feuille Ronde",
    "1621": "Graine Ma\u00eetrise",
    "1622": "Poké Ball",
    "1623": "???",
    "1624": "Gla\u00e7on Éternel",
    "1625": "Griffe de Créhelf",
    "1626": "Croc de Créfadet",
    "1627": "Aile de Créfollet",
    "1628": "Galet",
    "1629": "Fl\u00fbte Céleste",
    "1630": "Rem\u00e8de",
    "1631": "Super Rem\u00e8de",
    "1632": "Miel Kibrille",
    "1633": "Riz Zélé",
    "1634": "F\u00e8ve Dodue",
    "1635": "Champi Toumou",
    "1636": "Sel Rochedur",
    "1637": "Bois",
    "1638": "Herbe Souveraine",
    "1639": "Pacifi-Marais",
    "1640": "Poké Ball",
    "1641": "Super Ball",
    "1642": "Hyper Ball",
    "1643": "Plume Ball",
    "1644": "Poupée Pokéshi",
    "1645": "???",
    "1646": "Bombe Aveuglante",
    "1647": "Sachet Pétarade",
    "1648": "Boule Gluante",
    "1649": "Morceau d'Étoile",
    "1650": "App\u00e2t Toumou",
    "1651": "Plante Répulsive",
    "1652": "App\u00e2t Kibrille",
    "1653": "App\u00e2t Zélé",
    "1654": "App\u00e2t Dodu",
    "1655": "App\u00e2t Rochedur",
    "1656": "Potion",
    "1657": "Super Potion",
    "1658": "Hyper Potion",
    "1659": "Potion Max",
    "1660": "Guérison",
    "1661": "Rem\u00e8de",
    "1662": "Super Rem\u00e8de",
    "1663": "Hyper Rem\u00e8de",
    "1664": "Vieux G\u00e2teau",
    "1665": "Rusti-Muffin",
    "1666": "Total Soin",
    "1667": "Rappel",
    "1668": "Rappel Max",
    "1669": "Soin PP",
    "1670": "Maxi Soin PP",
    "1671": "Solution Furtive",
    "1672": "???",
    "1673": "Offensive Extra",
    "1674": "Défense Extra",
    "1675": "Muscle +",
    "1676": "Esquive Extra",
    "1677": "Double Extra",
    "1678": "Pacifi-For\u00eat",
    "1679": "Fragment de Fer",
    "1680": "???",
    "1681": "Galet Noir",
    "1682": "Galet Azur",
    "1683": "???",
    "1684": "Boule de Boue",
    "1685": "???",
    "1686": "Pétaralgue",
    "1687": "Rutabagaz",
    "1688": "Noigrume Rongé",
    "1689": "Boule de Neige",
    "1690": "Boule Gluante",
    "1691": "Obsidienne",
    "1692": "Bloc de Tourbe",
    "1693": "Solution Furtive",
    "1694": "Soignon",
    "1695": "Bourgeon Vivace",
    "1696": "Plante PP",
    "1697": "???",
    "1698": "???",
    "1699": "Remplamulette 2",
    "1700": "Remplamulette 3",
    "1701": "Fortichampi",
    "1702": "Carapachampi",
    "1703": "Champinja",
    "1704": "Champiscoto",
    "1705": "Radis des Plages",
    "1706": "Remplamulette 4",
    "1707": "Remplamulette 5",
    "1708": "Truffe Sucrée",
    "1709": "App\u00e2te",
    "1710": "Poké Ball",
    "1711": "Super Ball",
    "1712": "Hyper Ball",
    "1713": "Plume Ball",
    "1714": "???",
    "1715": "???",
    "1716": "Sachet Pétarade",
    "1717": "Bombe Aveuglante",
    "1718": "???",
    "1719": "???",
    "1720": "Poupée Pokéshi",
    "1721": "Pacifi-Volcan",
    "1722": "Pacifi-Montagne",
    "1723": "Pacifi-Neige",
    "1724": "App\u00e2t Kibrille",
    "1725": "App\u00e2t Zélé",
    "1726": "App\u00e2t Dodu",
    "1727": "App\u00e2t Toumou",
    "1728": "App\u00e2t Rochedur",
    "1729": "En-cas Contraire",
    "1730": "Papillote Choix",
    "1731": "Bouchée Double",
    "1732": "Enduramulette 1",
    "1733": "Enduramulette 2",
    "1734": "Enduramulette 3",
    "1735": "Enduramulette 4",
    "1736": "Enduramulette 5",
    "1737": "Journal Déchiré",
    "1738": "Zenamulette 1",
    "1739": "Zenamulette 2",
    "1740": "Zenamulette 3",
    "1741": "Zenamulette 4",
    "1742": "Zenamulette 5",
    "1743": "Fragment de Mur",
    "1744": "App\u00e2ragruel",
    "1745": "Vieux Journal",
    "1746": "Envol Ball",
    "1747": "Propulse Ball",
    "1748": "Masse Ball",
    "1749": "Mégamasse Ball",
    "1750": "Gigamasse Ball",
    "1751": "Envol Ball",
    "1752": "Propulse Ball",
    "1753": "Masse Ball",
    "1754": "Baie Bouhlon",
    "1755": "Hyper Rem\u00e8de",
    "1756": "Offensive Extra",
    "1757": "Défense Extra",
    "1758": "Esquive Extra",
    "1759": "Sable Effort",
    "1760": "Cailloux Effort",
    "1761": "Pierre Effort",
    "1762": "Rocher Effort",
    "1763": "Rem\u00e8de Secret",
    "1764": "Remplamulette 1",
    "1765": "Objet Perdu",
    "1766": "Objet Perdu",
    "1767": "Objet Perdu",
    "1768": "Objet Perdu",
    "1769": "Objet Perdu",
    "1770": "???",
    "1771": "Origine Ball",
    "1772": "???",
    "1773": "???",
    "1774": "???",
    "1775": "???",
    "1776": "Minerai Origine",
    "1777": "Globe Adamant",
    "1778": "Globe Perlé",
    "1779": "Globe Platiné",
    "1780": "Plaque Renouveau",
    "1781": "???",
    "1782": "Bo\u00eete \u00e0 Outils",
    "1783": "Mégamasse Ball",
    "1784": "Gigamasse Ball",
    "1785": "Étrange Ball",
    "1786": "Pokédex",
    "1787": "Vieux Po\u00e8me (1)",
    "1788": "Vieux Po\u00e8me (2)",
    "1789": "Vieux Po\u00e8me (3)",
    "1790": "Vieux Po\u00e8me (4)",
    "1791": "???",
    "1792": "Vieux Po\u00e8me (5)",
    "1793": "Vieux Po\u00e8me (6)",
    "1794": "Vieux Po\u00e8me (7)",
    "1795": "Vieux Po\u00e8me (8)",
    "1796": "Vieux Po\u00e8me (9)",
    "1797": "Vieux Po\u00e8me (10)",
    "1798": "Vieux Po\u00e8me (11)",
    "1799": "Vieux Po\u00e8me (12)",
    "1800": "Vieux Po\u00e8me (13)",
    "1801": "Vieux Po\u00e8me (14)",
    "1802": "Vieux Po\u00e8me (15)",
    "1803": "Vieux Po\u00e8me (16)",
    "1804": "Vieux Po\u00e8me (17)",
    "1805": "Vieux Po\u00e8me (18)",
    "1806": "Vieux Po\u00e8me (19)",
    "1807": "Vieux Po\u00e8me (20)",
    "1808": "Éclat Étrange S",
    "1809": "Éclat Étrange L",
    "1810": "Foreuse",
    "1811": "Tablette Kanto",
    "1812": "Tablette Johto",
    "1813": "Tablette C\u0153ur",
    "1814": "Tablette Arc-en-ciel",
    "1815": "Tablette Temp\u00eate",
    "1816": "Tablette Océans",
    "1817": "Tablette Continents",
    "1818": "Tablette Cieux",
    "1819": "Tablette Génétique",
    "1820": "Tablette Guides",
    "1821": "Tablette Distorsion",
    "1822": "Lecteur DS",
    "1828": "Plaque Légende",
    "1842": "Petit Bambou",
    "1843": "Gros Bambou",
    "1861": "Armure de la Rancune",
    "1862": "Téra-Éclat Normal",
    "1863": "Téra-Éclat Feu",
    "1864": "Téra-Éclat Eau",
    "1865": "Téra-Éclat Électrik",
    "1866": "Téra-Éclat Plante",
    "1867": "Téra-Éclat Glace",
    "1868": "Téra-Éclat Combat",
    "1869": "Téra-Éclat Poison",
    "1870": "Téra-Éclat Sol",
    "1871": "Téra-Éclat Vol",
    "1872": "Téra-Éclat Psy",
    "1873": "Téra-Éclat Insecte",
    "1874": "Téra-Éclat Roche",
    "1875": "Téra-Éclat Spectre",
    "1876": "Téra-Éclat Dragon",
    "1877": "Téra-Éclat Tén\u00e8bres",
    "1878": "Téra-Éclat Acier",
    "1879": "Téra-Éclat Fée",
    "1880": "Énergie Booster",
    "1881": "Garde-Talent",
    "1882": "Talisman Sain",
    "1883": "Feuille Copieuse",
    "1884": "Gant de Boxe",
    "1885": "Cape Obscure",
    "1886": "Dé Pipé",
    "2160": "CT100",
    "2161": "CT101",
    "2162": "CT102",
    "2163": "CT103",
    "2164": "CT104",
    "2165": "CT105",
    "2166": "CT106",
    "2167": "CT107",
    "2168": "CT108",
    "2169": "CT109",
    "2170": "CT110",
    "2171": "CT111",
    "2172": "CT112",
    "2173": "CT113",
    "2174": "CT114",
    "2175": "CT115",
    "2176": "CT116",
    "2177": "CT117",
    "2178": "CT118",
    "2179": "CT119",
    "2180": "CT120",
    "2181": "CT121",
    "2182": "CT122",
    "2183": "CT123",
    "2184": "CT124",
    "2185": "CT125",
    "2186": "CT126",
    "2187": "CT127",
    "2188": "CT128",
    "2189": "CT129",
    "2190": "CT130",
    "2191": "CT131",
    "2192": "CT132",
    "2193": "CT133",
    "2194": "CT134",
    "2195": "CT135",
    "2196": "CT136",
    "2197": "CT137",
    "2198": "CT138",
    "2199": "CT139",
    "2200": "CT140",
    "2201": "CT141",
    "2202": "CT142",
    "2203": "CT143",
    "2204": "CT144",
    "2205": "CT145",
    "2206": "CT146",
    "2207": "CT147",
    "2208": "CT148",
    "2209": "CT149",
    "2210": "CT150",
    "2211": "CT151",
    "2212": "CT152",
    "2213": "CT153",
    "2214": "CT154",
    "2215": "CT155",
    "2216": "CT156",
    "2217": "CT157",
    "2218": "CT158",
    "2219": "CT159",
    "2220": "CT160",
    "2221": "CT161",
    "2222": "CT162",
    "2223": "CT163",
    "2224": "CT164",
    "2225": "CT165",
    "2226": "CT166",
    "2227": "CT167",
    "2228": "CT168",
    "2229": "CT169",
    "2230": "CT170",
    "2231": "CT171",
    "2232": "CT172",
    "2233": "CT173",
    "2234": "CT174",
    "2235": "CT175",
    "2236": "CT176",
    "2237": "CT177",
    "2238": "CT178",
    "2239": "CT179",
    "2240": "CT180",
    "2241": "CT181",
    "2242": "CT182",
    "2243": "CT183",
    "2244": "CT184",
    "2245": "CT185",
    "2246": "CT186",
    "2247": "CT187",
    "2248": "CT188",
    "2249": "CT189",
    "2250": "CT190",
    "2251": "CT191",
    "2252": "CT192",
    "2253": "CT193",
    "2254": "CT194",
    "2255": "CT195",
    "2256": "CT196",
    "2257": "CT197",
    "2258": "CT198",
    "2259": "CT199",
    "2260": "CT200",
    "2261": "CT201",
    "2262": "CT202",
    "2263": "CT203",
    "2264": "CT204",
    "2265": "CT205",
    "2266": "CT206",
    "2267": "CT207",
    "2268": "CT208",
    "2269": "CT209",
    "2270": "CT210",
    "2271": "CT211",
    "2272": "CT212",
    "2273": "CT213",
    "2274": "CT214",
    "2275": "CT215",
    "2276": "CT216",
    "2277": "CT217",
    "2278": "CT218",
    "2279": "CT219",
    "2280": "CT220",
    "2281": "CT221",
    "2282": "CT222",
    "2283": "CT223",
    "2284": "CT224",
    "2285": "CT225",
    "2286": "CT226",
    "2287": "CT227",
    "2288": "CT228",
    "2289": "CT229",
    "2344": "Armure de la Fortune",
    "2345": "Embl\u00e8me du Général",
    "2401": "Plume Enchantée",
    "2402": "Pomme Nectar",
    "2403": "Bol Médiocre",
    "2404": "Bol Exceptionnel",
    "2405": "Masque Turquoise",
    "2406": "Masque de la Pierre",
    "2407": "Masque du Puits",
    "2408": "Masque du Fourneau",
    "2409": "Carte Élégance Verte",
    "2410": "Morceau de Cristal",
    "2411": "Mochi Santé",
    "2412": "Mochi Force",
    "2413": "Mochi Armure",
    "2414": "Mochi Esprit",
    "2415": "Mochi Mental",
    "2416": "Mochi Sprint",
    "2417": "Si\u00e8ges Simples",
    "2418": "Si\u00e8ges de l'Académie",
    "2419": "Si\u00e8ges de l'Académie",
    "2420": "Si\u00e8ges Fantaisie",
    "2421": "Si\u00e8ges Verdoyants",
    "2422": "Si\u00e8ges Hantés",
    "2423": "Si\u00e8ges Tartan Jaunes",
    "2424": "Si\u00e8ges Tartan Bleus",
    "2425": "Si\u00e8ges Tartan Rouges",
    "2426": "Si\u00e8ges Hautes Herbes",
    "2427": "Si\u00e8ges Combat Pokémon",
    "2428": "Si\u00e8ges Kaiju",
    "2429": "Si\u00e8ges \u00e0 Rayures",
    "2430": "Si\u00e8ges \u00e0 Losanges",
    "2431": "Si\u00e8ges \u00e0 Pois",
    "2432": "Si\u00e8ges Mauves",
    "2433": "Si\u00e8ges Menthe",
    "2434": "Si\u00e8ges Beiges",
    "2435": "Si\u00e8ges Jaunes",
    "2436": "Si\u00e8ges Bleus",
    "2437": "Si\u00e8ges Roses",
    "2438": "Croc d'Abo",
    "2439": "Griffe de Sabelette",
    "2440": "Poils de Mélo",
    "2441": "Poils de Goupix",
    "2442": "Mucus de Ptitard",
    "2443": "Liane de Chétiflor",
    "2444": "Fragment de Racaillou",
    "2445": "Gaz de Smogo",
    "2446": "Croc de Goinfrex",
    "2447": "Poils de Fouinette",
    "2448": "Plume de Hoothoot",
    "2449": "Fil de Mimigal",
    "2450": "Poils de Capumain",
    "2451": "Dard de Yanma",
    "2452": "Croc de Scorplane",
    "2453": "Lave de Limagma",
    "2454": "Poils de Marcacrin",
    "2455": "Croc de Medhy\u00e8na",
    "2456": "Feuille de Nénupiot",
    "2457": "Tige de Grainipiot",
    "2458": "Fragment de Tarinor",
    "2459": "Fluide de Muciole",
    "2460": "Fluide de Lumivole",
    "2461": "Carapace d'Écrapince",
    "2462": "Écaille de Barpau",
    "2463": "Fragment de Skelénox",
    "2464": "Fragment de Korillon",
    "2465": "Sueur de Charpenti",
    "2466": "Feuille de Larveyette",
    "2467": "Plume de Couaneton",
    "2468": "Suie de Funécire",
    "2469": "Griffe de Kungfouine",
    "2470": "Plume de Vostourno",
    "2471": "Joyau de Strassie",
    "2472": "Branche de Brocél\u00f4me",
    "2473": "Fil de Larvibule",
    "2474": "Poudre de Bombydou",
    "2475": "Écaille de Bébécaille",
    "2476": "Duvet de Nigosier",
    "2477": "Graine de Morpeko",
    "2478": "Poudre de Poltchageist",
    "2479": "Mochi Renouveau",
    "2480": "Perche \u00e0 Motismart",
    "2481": "Charme Éclatant",
    "2482": "Métal Composite",
    "2483": "Carte Élégance Bleue",
    "2484": "Feuille de Mystherbe",
    "2485": "Aiguillon de Tentacool",
    "2486": "Duvet de Doduo",
    "2487": "Poils d'Otaria",
    "2488": "Coquille de Noeunoeuf",
    "2489": "Sueur de Debugant",
    "2490": "Croc de Rhinocorne",
    "2491": "Encre d'Hypotrempe",
    "2492": "Poils d'Élekid",
    "2493": "Poils de Magby",
    "2494": "Larme de Lokhlass",
    "2495": "Fragment de Porygon",
    "2496": "Électricité de Loupio",
    "2497": "Poils de Snubbull",
    "2498": "Plume d'Airmure",
    "2499": "Peinture de Queulorior",
    "2500": "Poils de Posipi",
    "2501": "Poils de Négapi",
    "2502": "Carapace de Kraknoix",
    "2503": "Griffe de Terhal",
    "2504": "Piquant de Kranidos",
    "2505": "Ongle de Dinoclier",
    "2506": "Crini\u00e8re de Zébibron",
    "2507": "Griffe de Rototaupe",
    "2508": "Coton de Doudouvet",
    "2509": "Sueur de Baggiguane",
    "2510": "Poils de Chinchidou",
    "2511": "Fluide de Nucléos",
    "2512": "Fil de Statitik",
    "2513": "Fragment de Gringolem",
    "2514": "Poils de Psystigri",
    "2515": "Encre de Sepiatop",
    "2516": "Plume de Picassaut",
    "2517": "Fil d'Araqua",
    "2518": "Fleur de Guérilande",
    "2519": "Carapace de Météno",
    "2520": "Cr\u00e8me de Cr\u00e8my",
    "2521": "Rouille de Duralugon",
    "2522": "Friandise Artikodin",
    "2523": "Friandise Électhor",
    "2524": "Friandise Sulfura",
    "2525": "Friandise Raikou",
    "2526": "Friandise Entei",
    "2527": "Friandise Suicune",
    "2528": "Friandise Lugia",
    "2529": "Friandise Ho-Oh",
    "2530": "Friandise Latias",
    "2531": "Friandise Latios",
    "2532": "Friandise Kyogre",
    "2533": "Friandise Groudon",
    "2534": "Friandise Rayquaza",
    "2535": "Friandise Cobaltium",
    "2536": "Friandise Terrakium",
    "2537": "Friandise Viridium",
    "2538": "Friandise Reshiram",
    "2539": "Friandise Zekrom",
    "2540": "Friandise Kyurem",
    "2541": "Friandise Solgaleo",
    "2542": "Friandise Lunala",
    "2543": "Friandise Necrozma",
    "2544": "Friandise Wushours",
    "2545": "Friandise Blizzeval",
    "2546": "Friandise Spectreval",
    "2547": "Disque Indigo",
    "2548": "Pique Volcanique",
    "2549": "Téra-Éclat Stellaire",
    "2550": "Chesnaughtite",
    "2551": "Clefablite",
    "2552": "Delphoxite",
    "2553": "Dragoninite",
    "2554": "Drampanite",
    "2555": "Emboarite",
    "2556": "Excadrillite",
    "2557": "Feraligite",
    "2558": "Floettite",
    "2559": "Greninjite",
    "2560": "Golurkite",
    "2561": "Hawluchanite",
    "2562": "Meganiumite",
    "2563": "Meowsticite",
    "2564": "Starmiite",
    "2565": "Victreebelite",
    "2566": "Skarmoryite",
    "2567": "Chandelurite",
    "2568": "Zygardite",
    "2569": "Glimmoranite",
    "2570": "Crabominite",
    "2571": "Raichuite X",
    "2572": "Raichuite Y",
    "2573": "Chimechite",
    "2574": "Absolite Z",
    "2575": "Staraptorite",
    "2576": "Garchompite Z",
    "2577": "Lucarionite Z",
    "2578": "Heatranite",
    "2579": "Darkranite",
    "2580": "Golisopite",
    "2581": "Magearnite",
    "2582": "Zeraorite",
    "2583": "Scovillainite",
    "2584": "Tatsugirite",
    "2585": "Baxcalibrite"
}
export default itemsFre;